"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("el-dialog", {
    staticClass: "add_dialog",
    attrs: {
      width: "600px",
      title: _vm.dialogTitle,
      visible: _vm.dialogVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.dialogVisible = $event;
      }
    }
  }, [_vm.editItem ? _c("el-form", {
    ref: "form",
    attrs: {
      rules: _vm.rules,
      model: _vm.form,
      "label-width": "120px"
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "姓名"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.editItem.cert_name) + "\n            ")]), _c("el-form-item", {
    attrs: {
      label: "手机号"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.editItem.mobile) + "\n            ")]), _c("el-form-item", {
    attrs: {
      label: "绑定电池",
      prop: "battery_id"
    }
  }, [_c("el-select", {
    attrs: {
      placeholder: "请选择",
      clearable: "",
      filterable: "",
      remote: "",
      "remote-method": _vm.remoteMethod,
      loading: _vm.loading
    },
    on: {
      "visible-change": function visibleChange($event) {
        return _vm.remoteMethod();
      }
    },
    model: {
      value: _vm.form.battery_id,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "battery_id", $$v);
      },
      expression: "form.battery_id"
    }
  }, _vm._l(_vm.batteryList, function (item, index) {
    return _c("el-option", {
      key: item.id,
      attrs: {
        label: item.battery_no,
        value: item.id
      }
    });
  }), 1)], 1)], 1) : _vm._e(), _c("div", {
    staticClass: "dialog-footer",
    attrs: {
      slot: "footer"
    },
    slot: "footer"
  }, [_c("el-button", {
    attrs: {
      size: "small"
    },
    on: {
      click: function click($event) {
        _vm.dialogVisible = false;
      }
    }
  }, [_vm._v("取 消")]), _c("el-button", {
    attrs: {
      size: "small",
      type: "primary"
    },
    on: {
      click: _vm.submit
    }
  }, [_vm._v("提 交")])], 1)], 1)], 1);
};
exports.render = render;
var staticRenderFns = [];
exports.staticRenderFns = staticRenderFns;
render._withStripped = true;